/**
 * 申請フォームの localStorage 一時保存（キーと表示ラベルの対応）
 */
export const APPLICATION_FORM_DRAFT_ENTRIES = [
  { formId: 'joined', storageKey: 'draft_joined', label: '入社届' },
  { formId: 'paid_leave', storageKey: 'draft_paid_leave', label: '有給申請' },
  { formId: 'remove', storageKey: 'draft_remove', label: '異動年月日' },
  { formId: 'name_change', storageKey: 'draft_name_change', label: '名前変更' },
  { formId: 'bank_change', storageKey: 'draft_bank_change', label: '振込先変更' },
  { formId: 'address_change', storageKey: 'draft_address_change', label: '住所変更' },
  { formId: 'trains_change', storageKey: 'draft_trains_change', label: '交通機関' },
  { formId: 'family_change', storageKey: 'draft_family_change', label: '家族異動' },
  { formId: 'retirement', storageKey: 'draft_retirement', label: '退職届' },
  { formId: 'mynumber', storageKey: 'draft_mynumber', label: 'マイナンバー' },
  { formId: 'specialLeave', storageKey: 'draft_special_leave', label: '特別休暇' },
];

function draftDataExists(raw) {
  if (raw == null || raw === '') return false;
  try {
    const o = JSON.parse(raw);
    if (!o || typeof o !== 'object') return false;
    return Object.keys(o).some((k) => {
      const v = o[k];
      if (v == null) return false;
      if (typeof v === 'string') return v.trim() !== '';
      if (Array.isArray(v)) return v.length > 0;
      if (typeof v === 'object') return Object.keys(v).length > 0;
      return true;
    });
  } catch {
    return false;
  }
}

export function notifyApplicationDraftSaved() {
  window.dispatchEvent(new CustomEvent('application-draft-saved'));
}

export function getAllApplicationDraftLines() {
  return APPLICATION_FORM_DRAFT_ENTRIES.filter((e) =>
    draftDataExists(localStorage.getItem(e.storageKey))
  ).map((e) => `${e.label}申請一時保存`);
}

/** 一時保存中の申請（表示用: タイトルとステータスを分けたい画面向け） */
export function getAllApplicationDraftItems() {
  return APPLICATION_FORM_DRAFT_ENTRIES.filter((e) =>
    draftDataExists(localStorage.getItem(e.storageKey))
  ).map((e) => ({
    formId: e.formId,
    label: e.label,
    title: `${e.label}申請`,
    statusText: "一時保存",
  }));
}

export function hasDraftForFormId(formId) {
  const entry = APPLICATION_FORM_DRAFT_ENTRIES.find((e) => e.formId === formId);
  if (!entry) return false;
  return draftDataExists(localStorage.getItem(entry.storageKey));
}

/** 一時保存がある formId の集合（一覧のバッジ用） */
export function getFormIdsWithDraft() {
  return new Set(
    APPLICATION_FORM_DRAFT_ENTRIES.filter((e) =>
      draftDataExists(localStorage.getItem(e.storageKey))
    ).map((e) => e.formId)
  );
}

export function draftLabelForFormId(formId) {
  return APPLICATION_FORM_DRAFT_ENTRIES.find((e) => e.formId === formId)?.label ?? formId;
}
